import { useEffect, useState } from "react";
import Cookies from "js-cookie";

import { API_GET_EMPLOYEE_FILE } from "../../../../../config/Endpoints.js";
import { Avatar } from "../../../ui/index.ts";
import { getApi } from "../../../../utils/api.ts";
import { useProfileImage } from "../../../../hooks/use-profile-image.tsx";

export type EmployeeTableAvatarProps = {
  employeeId: number;
  name: string;
  photoPath?: string;
  size?: "sm" | "md" | "lg" | "xl";
};

export function EmployeeTableAvatar({
  employeeId,
  name,
  photoPath,
  size = "md",
}: EmployeeTableAvatarProps) {
  const hasPhotoPath = photoPath != null && photoPath.trim() !== "";
  const profileById = useProfileImage(hasPhotoPath ? employeeId : undefined);
  const [photoSrc, setPhotoSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!photoPath?.includes("photoDir")) {
      setPhotoSrc(null);
      return;
    }

    const ac = new AbortController();
    const token = Cookies.get("accessToken");

    void getApi<Blob>(
      `${API_GET_EMPLOYEE_FILE}?filepath=${encodeURIComponent(photoPath)}`,
      token ?? undefined,
      "blob",
      ac.signal,
    )
      .then(({ data }) => {
        const url = URL.createObjectURL(data);
        setPhotoSrc((prev) => {
          if (prev) URL.revokeObjectURL(prev);
          return url;
        });
      })
      .catch(() => {
        setPhotoSrc((prev) => {
          if (prev) URL.revokeObjectURL(prev);
          return null;
        });
      });

    return () => {
      ac.abort();
      setPhotoSrc((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return null;
      });
    };
  }, [photoPath]);

  const src = profileById ?? photoSrc ?? undefined;

  return <Avatar name={name} src={src} size={size} />;
}
